/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Remove_Video_File_LabelInputs */



/**
* | output |
* | --- |
* | "Remove video file" |
*
* @param {Audio_Description_Export_Remove_Video_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_remove_video_file_label = /** @type {((inputs?: Audio_Description_Export_Remove_Video_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Remove_Video_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le fichier vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi file video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить видеофайл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar archivo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイルを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइल हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover arquivo de vídeo")
	return /** @type {LocalizedString} */ ("Remove video file")
});